<style lang="scss" scoped>
.c-pointer {
  cursor: pointer;
}
.ptc-box {
  .participant-image {
    transition: box-shadow 0.3s;
  }
  &:hover {
    .participant-image {
      box-shadow: 0 0 0 1px #405373;
    }
  }
}
.popover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  z-index: 10000;
  max-width: none;
  cursor: pointer;
  .popover-content {
    padding: 30px;
    background: #fff;
    margin: auto;
    width: 90%;
    border-radius: 3px;
    position: relative;
    margin-top: 50px;
    overflow: auto;
    max-height: 90vh;
    @media (min-width: 992px) {
      width: 50%;
    }
    .close {
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }
}
</style>

<template>
    <div>
        <div v-if="showViewingPoint && viewingPoint" class="popover" @click="viewingPoint = {}; showViewingPoint = false">
            <div @click.stop class="popover-content ff-ub-r fs-18">
                <div class="close" @click="viewingPoint = {}; showViewingPoint = false">
                    <i class="fal fa-times"></i>
                </div>
                <p class="text-primary point-text fs-28 ff-ub-b">{{ viewingPoint.title.rendered }}</p>
                <p class="ff-ub-r fs-18 mb-0" v-html="viewingPoint.intro"></p>
            </div>
        </div>

        <div v-for="participant in participants" class="col-12 col-md-6 col-lg-4 mb-40 last-mb-0 c-pointer ptc-box" @click="viewingPoint = participant; showViewingPoint = true">
            <div class="position-relative mb-3 list-participant-image">
                <div class="list-number list-number-absolute">
                  <component v-for="char in participant['number']" :is="`number-${char}`" color="#025253" :key="char"></component>
                </div>
                <img :src="participant['image']" :alt="participant['slug']" >
            </div>
            <p class="fs-26 font-weight-medium mb-0 enterpreneur-title font-italic text-primary">{{ participant['firstname']}} <strong class="highlight-pink">{{ participant['lastname'] }}</strong></p>
            <p v-if="false" class="fs-14 text-secondary">{{ participant['function'] }}</p>
        </div>
    </div>
</template>

<script>
export default {
  props: ["participants"],
  data() {
    return {
      viewingPoint: {},
      showViewingPoint: false,
    };
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/participants.vue